<template>
  <gj-modal
      notFooterPadding
      size="1300_auto"
      :visible.sync="modalVisible"
      :confirmLoading="confirmLoading"
      @cancel="cancel"
      @confirm="confirm">
    <template #header>新增否定商品投放</template>
    <template #content>
      <el-form
          ref="form"
          :model="form">
        <app-base-info
            ref="base"
            :form="form.baseInfoForm"
            :market-id="marketId"
            :campaign="campaign"
            :group="group"
            group-select
        ></app-base-info>
        <app-neg-target-picker
            ref="picker"
            :market-id="marketId"
            :form="form.manualTargetPickerForm"
            title="否定商品"
        ></app-neg-target-picker>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn} from "../../../../../../../../minxins";
  import AppBaseInfo from "../common/base-info";
  import AppNegTargetPicker from "../common/neg-target-picker";
  import {AdGroupEnum} from "../../../../../common/enum";
  import {addSdAdNegTarget} from "../../../../../../../../api/ad";
  import {isMeaningful} from "../../../../../../../../utils/common";

  export default {
    name: "app-add-sd-ad-neg-target",
    mixins: [modalMixIn],
    components: {AppNegTargetPicker, AppBaseInfo},
    props: {
      marketId: {
        required: true
      },
      campaign: {
        required: false,
        default: null
      },
      group: {
        required: false,
        default: null
      }
    },
    data() {
      return {
        form: {
          baseInfoForm: {
            campaignTargetType: AdGroupEnum.SD.targetingType.PRODUCT_TARGETING,
            campaignId: null,
            groupId: null,
          },
          manualTargetPickerForm: {
            items: []
          }
        }
      }
    },
    methods: {
      confirm() {
        const formValid = !['base', 'picker'].some(e => !this.$refs[e].formValidate());
        if (formValid) {
          const params = {
            marketId: this.marketId,
            campaignId: this.form.baseInfoForm.campaignId,
            campaignName: this.form.baseInfoForm.campaignName,
            groupId: this.form.baseInfoForm.groupId,
            groupName: this.form.baseInfoForm.groupName,
            targetingType: this.form.baseInfoForm.campaignTargetType,
            adsManualTargetingParamList: this.form.manualTargetPickerForm.items.map(e => {
              const params = {};
              if (isMeaningful(e.asin)) {
                params.asin = e.asin;
              }
              if (isMeaningful(e.id)) {
                params.brandId = e.id;
              }
              return params;
            })
          };
          this.confirmLoading = true;
          addSdAdNegTarget(params)
            .then(() => {
              this.$emit('created');
              this.$gjDestroy();
            })
            .complete(() => this.confirmLoading = false);
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../../common/common";

</style>
